import {FC} from 'react'
import Button from 'jbc-front/components/Button'
import {Section} from 'jbc-front/components/presenters/form/Section'
import {LoadingPage} from 'components/ui/LoadingPage'
import styles from '../Presenter.scss'

export const LoadingPlaceholder: FC = () => {
  return (
    <>
      <Section>
        <LoadingPage />
      </Section>
      <div className={styles.bottomButtonsArea}>
        <Button disabled>プレビュー</Button>
        <Button primary disabled>
          保存
        </Button>
      </div>
    </>
  )
}
